import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home.vue";
import { routesData } from "@/utils/permission";
import store from "../store/index";
Vue.use(VueRouter);

export const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    redirect: "/tj/douyin",
    children: [
      {
        path: "/manage/binhang",
        name: "/manage/binhang",
        component: () => import(`../views/binhang-manage/binhang-manage.vue`),
      },
      {
        path: "/manage/merchant",
        name: "/manage/merchant",
        component: () => import(`../views/merchant-manage/merchant-manage.vue`),
      },
      {
        path: "/qifu/carousel",
        name: "/qifu/carousel",
        component: () => import(`../views/qifu-manage/qifu-carousel.vue`),
      },
      {
        path: "/qifu/service",
        name: "/qifu/service",
        component: () => import(`../views/qifu-manage/qifu-service.vue`),
      },
      {
        path: "/tj/douyin",
        name: "/tj/douyin",
        component: () => import(`../views/tongji/douyin.vue`),
      },
      {
        path: "/info/activity",
        name: "/info/activity",
        component: () => import(`../views/info-manage/activity.vue`),
      },
      {
        path: "/info/review",
        name: "/info/review",
        component: () => import(`../views/info-manage/review.vue`),
      },
      {
        path: "/info/lesson",
        name: "/info/lesson",
        component: () => import(`../views/info-manage/lesson.vue`),
      },
      {
        path: "/info/about",
        name: "/info/about",
        component: () => import(`../views/info-manage/about.vue`),
      },
      {
        path: "/info/question",
        name: "/info/question",
        component: () => import(`../views/info-manage/question.vue`),
      },
      {
        path: "/info/message",
        name: "/info/message",
        component: () => import(`../views/info-manage/message.vue`),
      },
      {
        path: "/score/coupon",
        name: "/score/coupon",
        component: () => import(`../views/score-manage/coupon.vue`),
      },
      {
        path: "/score/situation",
        name: "/score/situation",
        component: () => import(`../views/score-manage/situation.vue`),
      },
      {
        path: "/system/mumber",
        name: "/system/mumber",
        component: () => import(`../views/system-manage/mumber.vue`),
      },
      {
        path: "/system/history",
        name: "/system/history",
        component: () => import(`../views/system-manage/history.vue`),
      },
      {
        path: "/person/customer",
        name: "/person/customer",
        component: () => import(`../views/person-manage/customer-list.vue`),
      },
      {
        path: "/person/customerActive",
        name: "/person/customerActive",
        component: () =>
          import(`../views/person-manage/customer-active.vue`),
      },
      {
        path: "/person/customerService",
        name: "/person/customerService",
        component: () =>
          import(`../views/person-manage/customer-service-list.vue`),
      },
      {
        path: "/person/feedback",
        name: "/person/feedback",
        component: () => import(`../views/person-manage/feedback-list.vue`),
      },
      {
        path: "/person/share",
        name: "/person/share",
        component: () => import(`../views/person-manage/share-list.vue`),
      },
      {
        path: "/person/photoshare",
        name: "/person/photoshare",
        component: () => import(`../views/person-manage/photoshare.vue`),
      },
      {
        path: "/personal",
        name: "/personal",
        component: () => import(`../views/personal-center/personal.vue`),
      },
      {
        path: "/info/userinfo",
        name: "/info/userinfo",
        component: () => import(`../views/info-manage/userinfo.vue`),
      },
      {
        path: '/binhang/business',
        name: '/binhang/business',
        component:() => import(`../views/official/business.vue`)
      },
      {
        path: '/binhang/cases',
        name: '/binhang/cases',
        component:() => import(`../views/official/cases.vue`)
      },
      {
        path: '/binhang/service',
        name: '/binhang/service',
        component:() => import(`../views/official/service.vue`)
      },
      {
        path: '/binhang/alliance',
        name: '/binhang/alliance',
        component:() => import(`../views/official/alliance.vue`)
      },
      {
        path: '/binhang/about',
        name: '/binhang/about',
        component:() => import(`../views/official/about.vue`)
      }
    ],
  },
  {
    path: "/404",
    name: "404",
    component: () => import(`../views/404.vue`),
  },
  {
    path: "/login",
    name: "login",
    component: () => import(`../views/login/Login.vue`),
  },
  {
    path: "/forget",
    name: "forget",
    component: () => import(`../views/login/forgotLogin.vue`),
  },
  {
    path: "/jump",
    name: "/jump",
    component: () => import(`../views/jumpPage/jump.vue`),
  },
];
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

const router = new VueRouter({
  routes,
});
router.reloadRouter = function () {
  router.matcher = new VueRouter({
    routes,
  }).matcher;
};
let hasRoles = true;
router.beforeEach(async (to, from, next) => {
  let token = window.localStorage.getItem("TOKEN");
  if (token) {
    //如果已经登录直接跳转首页
    if (to.path === "/login") {
      next({ path: "/" });
    } else {
      next();
    }
  } else if (to.path != "/login" && to.path != "/forget" && to.path != "/jump") {
    next("/login");
  } else {
    next();
  }
  // if(to.matched.length === 0 && hasRoles == false){
  // 	next('/404')
  // }else{
  // 要去登录界面,直接放行
  // if (to.path === '/login') {
  // 	next();
  // } else {
  // const token = localStorage.getItem('token');
  // if (!token) {
  // 	next('/login')
  // } else {
  // if(hasRoles){
  // 	await routesData(store.state.userpower)
  // 	hasRoles = false
  // 	next({...to,replace: true})
  // }else{
  // 	next();
  // }

  // }
  // }
  // }
});

export default router;
